import { FiltersVisibilityButton, Loader, Table } from '@lifebit-ai/lds'
import React from 'react'

import { TablePaginationContainer, TableWrapper } from 'core/Common.styles'
import ImportRequestsRowHoverOverlay from 'modules/requests/ExportAndAccessRequestsTable/ImportRequestsRowHoverOverlay'
import {
  EmptyStateContainer,
  LoadingContainer
} from 'modules/requests/ExportAndAccessRequestsTable/RequestsTable.styles'
import * as styles from 'modules/requests/ExportAndAccessRequestsTable/RequestsTable.styles'
import { FileNameFilter } from 'modules/requests/FileNameFilter'
import { ImportRequestAssigneeFilter } from 'modules/requests/ImportRequestAssigneeFilter'
import ImportRequestAssignToModal from 'modules/requests/ImportRequestAssignToModal'
import { ImportRequestLabelsFilter } from 'modules/requests/ImportRequestLabelsFilter'
import { ImportRequestRequestedByFilter } from 'modules/requests/ImportRequestRequestedByFilter'
import { ImportRequestWorkspacesFilter } from 'modules/requests/ImportRequestWorkspacesFilter'
import { ImportRequestScanResultFilter } from 'modules/requests/filters/ImportRequestScanResultFilter'
import { ImportRequestStatusFilter } from 'modules/requests/filters/ImportRequestStatusFilter'
import { useImportRequestsTablePage } from 'modules/requests/hooks/useImportRequestsTablePage'
import type { ImportRequestVerificationListItem } from 'services/import-requests/types'

export const IMPORT_REQUESTS_TABLE_WRAPPER_TEST_ID = 'import-requests-table-wrapper-test-id'
export const IMPORT_REQUESTS_LOADING_CONTAINER_TEST_ID = 'import-requests-loading-container-test-id'

const LoadingIcon = () => {
  return (
    <LoadingContainer data-testid={IMPORT_REQUESTS_LOADING_CONTAINER_TEST_ID}>
      <Loader text={false} />
    </LoadingContainer>
  )
}

const ImportRequestsTable = () => {
  const {
    activeFiltersCount,
    applyCheckboxFilter,
    applyFileNameFilter,
    areFiltersVisible,
    assignModalState,
    closeAssignModal,
    columns,
    importRequests,
    isLoading,
    openAssignModal,
    openImportRequest,
    resetCheckboxFilter,
    resetFileNameFilter,
    showPagination,
    tablePagination,
    toggleFiltersVisibility,
    unassignImportRequest
  } = useImportRequestsTablePage()

  return (
    <TableWrapper data-testid={IMPORT_REQUESTS_TABLE_WRAPPER_TEST_ID}>
      <Table<ImportRequestVerificationListItem>
        rowKey="_id"
        data-testid="import-requests-table"
        columns={columns}
        data={importRequests}
        onRowClicked={(_, row) => openImportRequest(row.original._id)}
        loading={isLoading}
        loadingIcon={<LoadingIcon />}
        emptyComponent={<EmptyStateContainer>No import requests found</EmptyStateContainer>}
        rowHoverOverlay={row => (
          <ImportRequestsRowHoverOverlay
            row={row}
            onAssignTo={openAssignModal}
            onUnassignFrom={unassignImportRequest}
          />
        )}
        pagination={tablePagination}
      >
        <styles.FiltersVisibilityButtonWrapper>
          <FiltersVisibilityButton
            areFiltersVisible={areFiltersVisible}
            numActiveFilters={activeFiltersCount}
            onClick={toggleFiltersVisibility}
          />
        </styles.FiltersVisibilityButtonWrapper>
        {areFiltersVisible && (
          <styles.FiltersContainer>
            <ImportRequestStatusFilter
              onApply={applyCheckboxFilter('status')}
              onReset={resetCheckboxFilter('status')}
            />
            <ImportRequestScanResultFilter
              onApply={applyCheckboxFilter('scanResult')}
              onReset={resetCheckboxFilter('scanResult')}
            />
            <FileNameFilter onApply={applyFileNameFilter} onReset={resetFileNameFilter} />
            <ImportRequestLabelsFilter
              onApply={applyCheckboxFilter('labelIds')}
              onReset={resetCheckboxFilter('labelIds')}
            />
            <ImportRequestWorkspacesFilter
              onApply={applyCheckboxFilter('workspaceIds')}
              onReset={resetCheckboxFilter('workspaceIds')}
            />
            <ImportRequestRequestedByFilter
              onApply={applyCheckboxFilter('requesterIds')}
              onReset={resetCheckboxFilter('requesterIds')}
            />
            <ImportRequestAssigneeFilter
              onApply={applyCheckboxFilter('assigneeIds')}
              onReset={resetCheckboxFilter('assigneeIds')}
            />
          </styles.FiltersContainer>
        )}
        <Table.TableContainer>
          <Table.Body />
          {showPagination ? (
            <TablePaginationContainer>
              <Table.Pagination />
            </TablePaginationContainer>
          ) : null}
        </Table.TableContainer>
      </Table>
      {assignModalState && (
        <ImportRequestAssignToModal
          requestId={assignModalState.requestId}
          assignedTo={assignModalState.assignedTo}
          open
          onClose={closeAssignModal}
        />
      )}
    </TableWrapper>
  )
}

export default ImportRequestsTable
